// QuestionPanel.js
import { Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { WarningOutlined } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import styles from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import RegularButton from "components/CustomButtons/Button";
import { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { addBulkPdfQuestions } from "services/PdfPlayerServices/questionService";
import { questionTypeMapUI } from "utils/formatChoices";
import * as XLSX from "xlsx";
import QuestionCard from "./QuestionCard";



const useStyles = makeStyles((theme) => ({
    ...styles,
    tooltip: {
        fontSize: "1em",
    },
}));

export default function QuestionPanel({ config, onFinish }) {
    const classes = useStyles();
    const [answers, setAnswers] = useState({});
    const [open, setOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [severity, setSeverity] = useState("success");
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(null);

    const showSnackBar = (message, sev) => {
        setSeverity(sev ?? "success");
        setAlertMessage(message);
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setAlertMessage(null);
        setOpen(false);
    };

    const handleSelect = (qIndex, value) => {
        setAnswers((prev) => ({ ...prev, [qIndex]: value }));
    };

    // Excel Upload Handler
    const handleExcelUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            const newAnswers = {};
            jsonData.forEach((row) => {
                const qNumber = row.QuestionNumber;
                let ans = row.Answer;

                if (!qNumber || qNumber > config.questionCount) return;

                if (normalizedConfig.questionType === "SCQ") {
                    ans = ans?.toString().trim();
                }

                if (normalizedConfig.questionType === "Numerical") {
                    if (isNaN(ans)) return; // ignore invalid numbers
                }

                newAnswers[qNumber - 1] = ans.toString();
            });
            // jsonData.forEach((row) => {
            //     const qNumber = row.QuestionNumber;
            //     const ans = row.Answer;

            //     if (
            //         qNumber &&
            //         qNumber <= config.questionCount
            //     ) {
            //         newAnswers[qNumber - 1] = ans.toString();
            //     }
            // });

            // setAnswers(newAnswers);
            setAnswers(prev => ({ ...prev, ...newAnswers }));
        };

        reader.readAsArrayBuffer(file);
    };

    const buildPayload = () => {
        const questions = Array.from({ length: config.questionCount }).map(
            (_, i) => ({
                questionNumber: i + 1,
                questionType: config?.questionType, //questionTypeMap[config.questionType],
                correctAnswer: answers[i] || "",
                numberOfChoices: config.noOfChoices,
                choiceFormatId: config?.choiceFormat - 1,
            })
        );

        return {
            providerId: config.providerId,
            poolId: config.poolId,
            topicId: typeof (config.topics) == 'string' ? Number(config.topics) : config.topics,
            createdBy: config.createdBy,
            questions,
        };
    };

    const handleSubmit = async () => {
        try {
            const payload = buildPayload();

            console.log("Sending Payload:", payload);
            setLoading(true);

            const response = await addBulkPdfQuestions(payload);

            console.log("Success:", response);
            showSnackBar("Questions saved successfully!", 'success');
            setLoading(false);
            setTimeout(() => {
                onFinish();
            }, 2000)
        } catch (error) {
            setLoading(false);
            showSnackBar("Failed to save questions.", "error");
        }
    };

    const normalizedConfig = {
        ...config,
        questionType: questionTypeMapUI[Number(config.questionType)],
    };
    return (
        <div style={{ padding: 20 }}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "20px",
                }}
            >
                {/* Excel Upload Label + Input */}
                <div style={{ alignItems: "center", gap: "8px" }}>
                    <label style={{ fontWeight: 500 }}>
                        Upload Answers Using Excel
                    </label>

                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleExcelUpload}
                    />
                </div>
                {/* Submit Button */}
                <RegularButton
                    color="primary"
                    disabled={loading}
                    onClick={() => {
                        setAlert(
                            <SweetAlert
                                style={{ display: "block", marginTop: "-100px" }}
                                title={""}
                                showCancel={true}
                                confirmBtnText={"OK"}
                                cancelBtnText={"CANCEL"}
                                onConfirm={() => {
                                    setAlert(null);
                                    handleSubmit(); // actual API call
                                }}
                                onCancel={() => setAlert(null)}
                                confirmBtnCssClass={classes.button + " " + classes.success}
                                cancelBtnCssClass={classes.button + " " + classes.warning}
                            >
                                <div style={{ alignItems: "center" }}>
                                    <WarningOutlined
                                        style={{
                                            marginRight: "8px",
                                            color: "brown",
                                        }}
                                    />
                                    <br />
                                    <br />
                                    <h5 style={{ margin: 0, textTransform: 'none', fontSize: "unset", fontWeight: 300 }}>
                                        This is a one-time activity for question creation.
                                        You can update questions later. <br /><br />
                                        Do you want to create questions ?
                                    </h5>
                                </div>
                            </SweetAlert>
                        );
                    }}
                >
                    {loading ? "Loading..." : "Submit"}
                </RegularButton>
                {/* <RegularButton color="primary" onClick={handleSubmit}>
                    {loading ? 'Loading...' : 'Submit'}
                </RegularButton> */}

            </div>
            {/* <RegularButton color="primary" onClick={handleSubmit}>Submit</RegularButton>
            <div style={{ marginBottom: 20 }}>
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleExcelUpload}
                />
            </div> */}

            {Array.from({ length: config.questionCount }).map((_, i) => (
                <QuestionCard
                    key={i}
                    index={i}
                    // config={{ ...config, questionType: uiQuestionType }}
                    config={normalizedConfig}
                    selectedAnswer={answers[i]}
                    onSelect={handleSelect}
                />
            ))}

            {<Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleClose} severity={severity}>
                    {alertMessage}
                </Alert>
            </Snackbar>}
            {alert}
        </div>
    );
}

// import { useState } from "react";
// import QuestionCard from "./QuestionCard";

// export default function QuestionPanel({ config }) {
//     const [answers, setAnswers] = useState({});

//     const handleSelect = (qIndex, value) => {
//         setAnswers((prev) => ({ ...prev, [qIndex]: value }));
//     };

//     return (
//         <div style={{ padding: 20 }}>
//             <h3>Answer Sheet</h3>

//             {Array.from({ length: config.questionCount }).map((_, i) => (
//                 <QuestionCard
//                     key={i}
//                     index={i}
//                     config={config}
//                     selectedAnswer={answers[i]}
//                     onSelect={handleSelect}
//                 />
//             ))}

//             <button onClick={() => console.log("Submitted:", answers)}>
//                 Submit
//             </button>
//         </div>
//     );
// }